<template>
  <ModuleSection
    :title="title"
    class="transfer-result-page"
  >
    <Result :tipMessage="tipMessage" />
    <div class="transfer-result-btns">
      <el-button
        v-if="$route.query.type === 'add'"
        class="transfer-next"
        @click="handleContinue"
        type="primary"
      >{{ $t('继续添加') }}</el-button>
      <el-button
        class="transfer-back"
        @click="goBack"
        type="info"
      >{{ $t('返回') }}</el-button>
    </div>
  </ModuleSection>
</template>

<script>
import ModuleSection from '@/components/container/ModuleSection'
import Result from '@/components/common/Result'

export default {
  components: {
    ModuleSection,
    Result
  },
  computed: {
    title () {
      const { recBankType } = this.$route.query
      return this.$t('收款人名册') + '-' + (recBankType === 1 ? this.$t('他行账户') + '-' : this.$t('本行账户'))
    },
    tipMessage () {
      const { type } = this.$route.query
      return type === 'modify' ? this.$t('收款人修改成功') : this.$t('收款人添加成功')
    }
  },
  methods: {
    handleContinue () {
      this.$router.back()
    },
    // 返回
    goBack () {
      this.$router.push({
        name: 'PayeeListOutwardList'
      })
    }

  }
}
</script>

<style lang="less" scoped>
.transfer-result-page {
  .transfer-result-message {
    margin: 60px auto 0;
    width: 500px;
    padding: 40px 10px 40px 0;
    border-radius: 10px;
    border: 1px dashed #d7dbec;

    ul {
      li {
        display: flex;
        align-items: center;
        padding-left: 132px;
        margin-bottom: 30px;

        label {
          width: 120px;
          margin-right: 10px;
          color: #333752;
          font-size: 14px;
        }

        span {
          color: #5a607f;
          font-size: 14px;
        }

        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }

  .transfer-result-btns {
    display: flex;
    justify-content: center;

    .transfer-next,
    .transfer-back {
      min-width: 140px;
    }
  }

  .transfer-result-tip {
    text-align: center;
    color: #131523;
    font-size: 16px;
    margin: 20px 0 40px;
  }

  .transfer-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    position: relative;

    .transfer-result-back {
      width: 100%;
      height: 123px;
      background: linear-gradient(
        180deg,
        rgba(251, 252, 254, 0) 0%,
        #f6f7fc 100%
      );
      border-radius: 10px;
      position: absolute;
      left: 0;
      top: -14px;
    }

    img {
      position: relative;
      z-index: 2;
      width: 220px;
      height: 150px;
      margin-bottom: 20px;
    }
  }
}
</style>
